module.exports = __webpack_public_path__ + "static/media/Velasca - Orange - DK Chocolate_White.da50175e.jpg";